import { defineStore } from "pinia";
import { mande } from "mande";

export interface Blogpost {
    id: number;
    slug: string;
    status: string;
    featured_image_url: string;
    title: {
        rendered: string;
    };
    post_name: string;
    post_title: string;
    acf: {
        description: string;
    };
}

export interface BlogFilter {
    page?: number;
}

const api = mande("/api");
const json = mande("/json");

export const useBlogStore = defineStore("blog", {
    state: () => {
        return {
            all: [],
            viewing: undefined,
        } as { all: Blogpost[]; viewing?: number };
    },

    actions: {
        async indexBlogposts(blogFilter?: BlogFilter): Promise<Blogpost[]> {
            const blogposts = await api.get<{ status: number; data: Blogpost[] }>("blog", blogFilter ? { query: blogFilter } : undefined);

            if (blogposts.status === 200) {
                if (blogFilter && blogFilter.page && blogFilter.page > 1) {
                    this.all.push(...blogposts.data);
                } else {
                    this.all = blogposts.data;
                }
            }

            return this.all;
        },
    },
});
